import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
export class PitchDeviceBoxAdapter {
    type = "midi-effect";
    accepts = "midi";
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            octaves: this.#parametric.createParameter(box.octaves, ValueMapping.linearInteger(-7, 7), StringMapping.numeric({ unit: "oct", fractionDigits: 0 }), "octaves"),
            semiTones: this.#parametric.createParameter(box.semiTones, ValueMapping.linearInteger(-36, 36), StringMapping.numeric({ unit: "st", fractionDigits: 0 }), "semi-tones"),
            cent: this.#parametric.createParameter(box.cents, ValueMapping.linear(-50.0, 50.0), StringMapping.numeric({ unit: "cents", fractionDigits: 1 }), "cents")
        };
    }
}
